import { CSSProperties, useRef } from 'react';
import { useAudioVolume } from '../../hooks/useAudioVolume';
import { Container, Segment } from './view';

const SEGMENTS_COUNT = 12;
const GAP_WIDTH = 3;

export const VolumeIndicator = () => {
    const containerRef = useRef<HTMLDivElement | null>(null);

    useAudioVolume({
        onLevelChange: (level) => {
            containerRef.current?.style.setProperty('--volume', String(level));
        },
    });

    return (
        <Container ref={containerRef}>
            {Array.from({ length: SEGMENTS_COUNT }, (_, i) => (
                <Segment
                    key={i}
                    style={{ '--threshold': i / SEGMENTS_COUNT } as CSSProperties}
                    $gapWidth={GAP_WIDTH}
                    $segmentsCount={SEGMENTS_COUNT}
                />
            ))}
        </Container>
    );
};

VolumeIndicator.displayName = 'VolumeIndicator';
